import './OrderPage.css';

import logoImage from './../../image/logo.svg';
import photo from './../../image/photo-icon.png';
import productPhoto from './../../image/product-photo.png';

const OrderPage = ({ orderList, setIsShowSuccess, setSuccessStatus }) => {
    // форматирование даты
    const formatDate = (ordersDate) => {
        const date = new Date(ordersDate);
        const timeZoneOffset = new Date().getTimezoneOffset();
        const localDate = new Date(date.getTime() - timeZoneOffset * 60 * 1000);

        const year = localDate.getFullYear();
        const day = localDate.getDate().toString().padStart(2, '0');
        const month = (localDate.getMonth() + 1).toString().padStart(2, '0');

        return `${day}/${month}/${year}`;
    };

    // добавление товара
    const handleProductClick = (order) => {
        let newTotalSum = parseInt(localStorage.getItem('totalSum') || 0);

        const productInfo = {
            id: order.productId,
            name: order.name,
            price: order.price,
            quantity: order.amount,
        };

        const currentCart = JSON.parse(
            localStorage.getItem(`product_${order.productId}`)
        ) || { quantity: 0 };

        const newQuantity = currentCart.quantity + order.amount;
        const updatedProductInfo = { ...productInfo, quantity: newQuantity };

        localStorage.setItem(
            `product_${order.productId}`,
            JSON.stringify(updatedProductInfo)
        );

        newTotalSum += order.price * order.amount;
        localStorage.setItem('totalSum', newTotalSum);

        setSuccessStatus(4);
        setIsShowSuccess(true);
    };

    return (
        <div className='order_wrapper'>
            <div className='order__logo'>
                <img src={logoImage} alt='Logo' />
            </div>
            <h3 className='order__title'>Мои заказы</h3>
            {orderList && (
                <h3 className='order__subtitle'>
                    Заказ от <span>{formatDate(orderList.createdAt)}</span>
                </h3>
            )}
            <div className='order__items'>
                {orderList &&
                    orderList.orderItems.map((order) => (
                        <div className='order__item' key={order.itemId}>
                            <div className='order__item_image'>
                                <img
                                    src={
                                        order.imageUrl
                                            ? `https://apihpwild.ru${order.imageUrl}`
                                            : productPhoto
                                    }
                                    alt={order.name}
                                />
                            </div>
                            <div className='order__item_info'>
                                <p className='order__item_info_name'>
                                    {order.name}
                                </p>
                                <p className='order__item_info_weight'>
                                    {order.productWeight} г.
                                </p>
                            </div>
                            <div className='order__item_add'>
                                <div className='order__item_add_info'>
                                    {order.amount} шт. •{' '}
                                    <span>{order.price}₽</span>
                                </div>
                                <div
                                    className='order__item_add_btn'
                                    onClick={() => handleProductClick(order)}
                                >
                                    Заказать снова
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
            {orderList && (
                <div className='order__summ'>
                    <h5 className='order__summ_title'>ИТОГО</h5>
                    <p className='order__summ_count'>{orderList.price}₽</p>
                </div>
            )}
        </div>
    );
};

export default OrderPage;
